//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import tabbox from '@/components/ui/tabbox';
import loadmore from '@/components/ui/loadmore';

import goodsList from '@/components/goodsList';
import mainMenuTab from "@/components/mainMenuTab";

export default {
    components: {mainMenuTab,goodsList,cardbox,navbar,tabbox,loadmore},
    data(){
        return {
            tabData: [
                {label:'已下单',value: 11, active: false},
                {label:'待发货',value: 20, active: false},
                {label:'已完成',value: 40, active: false},
                {label:'已取消',value: 0, active: false},
            ],
            order: {
                total: 0,
                current_page: 1,
                per_page: 100,
                data: []
            },
            currentTab: 11,
            currentIndex: 0,
        }
    },
    filters: {
        timer: function(value){
            if(!value) return '';
            let date = new Date(value*1000);
            return common.formatDate(date);
        }
    },
    methods:{

        // 继续支付
        toPayment(item){
            common.sessionJson('orderConfirm',{
                store_id: item.buyer_id,
                store_name: item.seller_name,
                storePrice: Number(item.goods_amount),
                storeDeposit: Number(item.goods_deposit),
                storeShipping: Number(item.extm.shipping_fee),
                coupon: item.coupon_sn,
                storeCoupon: {coupon_value: Number(item.discount)},
                out_trade_no: item.order_sn,
            })

            this.$router.push('/pay/wx/')
        },

        // 重新购买
        addCart(itemList){

            let specid = [],quantity=[];

            itemList.forEach(val=>{
                if(val.spec_id>0 && val.quantity>0){
                    specid.push(val.spec_id);
                    quantity.push(val.quantity);
                }
            })

            const opts = {
                url: api.cartAdd,
                data: {
                    spec_id: specid.join(),
                    quantity: quantity.join()
                }
            }

            common.query(opts).then(res=>{
                this.$router.push("/cart");
            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 取消订单
        cancelOrder(item){

            const _this = this;

            const opts = {
                url: api.myOrderCancel,
                data: {
                    id: item.order_id
                },
                type: 'put'
            }

            this.$vux.confirm.show({
                title: '订单操作',
                content: '确认是否取消订单?',
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.$vux.toast.text("操作成功。",'top');
                        _this.initTab(3);
                    },res=>{
                        _this.$vux.toast.text(res.message);
                    })
                }
            })

        },

        // 切换tab
        changeTab(item,index){
            if(this.currentTab !== item.value){
                this.currentTab = item.value;
                this.currentIndex = index;
                this.queryMyOrder();
            }
        },

        // 查询订单
        queryMyOrder(){

            const opts = {
                url: api.myOrder,
                data: {
                    status: this.currentTab
                },
                type: 'get'
            }
            common.query(opts).then(res=>{

                this.order = res.data;
                console.log(this.order);

            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

        // 初始化tab状态
        initTab(val){

            let index = 0;
            if(val){
                index = val
            }else{
                index = this.$route.query.tab ? this.$route.query.tab : 0 ;
            }

            this.tabData.forEach(val=>{
                val.active = false;
            })

            this.tabData[index].active = true;
            this.currentTab = this.tabData[index].value;
            this.currentIndex = index;

            this.queryMyOrder();
        },

    },
    mounted(){
        this.initTab();
    },
}




// WEBPACK FOOTER //
// ./src/views/member/order.vue